import React from 'react';
import { Container } from '@mui/material';
import WarehouseTransferRequestList from '../components/warehouseTransfers/WarehouseTransferRequestList';
import DashboardLayout from '../components/dashboard/DashboardLayout';

const WarehouseTransferRequests: React.FC = () => {
  return (
    <DashboardLayout>
      <WarehouseTransferRequestList />
    </DashboardLayout>
  );
};

export default WarehouseTransferRequests;